import type { FormValues } from '../types/adSearchFormValues';
import type { ExtendedAdsQueryVariables } from '../types/extendedAdsQueryVariables';

export const adsQueryVariablesToFormValues = (queryVariables?: ExtendedAdsQueryVariables): FormValues => ({
    ...queryVariables,
    rooms: queryVariables?.rooms ? String(queryVariables.rooms) : 'default',
    maxPrice: queryVariables?.maxPrice ? String(queryVariables.maxPrice) : '',
    minPrice: queryVariables?.minPrice ? String(queryVariables.minPrice) : '',
    minLivingArea: queryVariables?.minLivingArea ? String(queryVariables.minLivingArea) : '',
    maxLivingArea: queryVariables?.maxLivingArea ? String(queryVariables.maxLivingArea) : '',
    orderBy: JSON.stringify(queryVariables?.orderBy),
});

export const formValuesToAdsQueryVariables = (formValues?: FormValues): ExtendedAdsQueryVariables => ({
    ...formValues,
    orderBy: JSON.parse(formValues?.orderBy as string) as ExtendedAdsQueryVariables['orderBy'],
    rooms: formValues && formValues.rooms !== 'default' ? Number(formValues.rooms) : undefined,
    maxPrice: formValues && formValues.maxPrice !== '' ? Number(formValues.maxPrice) : undefined,
    minPrice: formValues && formValues.minPrice !== '' ? Number(formValues.minPrice) : undefined,
    minLivingArea: formValues && formValues.minLivingArea !== '' ? Number(formValues.minLivingArea) : undefined,
    maxLivingArea: formValues && formValues.maxLivingArea !== '' ? Number(formValues.maxLivingArea) : undefined,
});
